import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./MediaLibraryIndex'),
  loading: () => <Loading withContentWrapper />,
});

export const List = Loadable({
  loader: () => import('./MediaLibraryList'),
  loading: () => <Loading withContentWrapper />,
});

export const Form = Loadable({
  loader: () => import('./MediaLibraryFormPage'),
  loading: () => <Loading withContentWrapper />,
});

export const FilesList = Loadable({
  loader: () => import('./MediaFilesListFormPage'),
  loading: () => <Loading withContentWrapper />,
});

export const FileDetailsForm = Loadable({
  loader: () => import('./MediaFileDetailsFormPage'),
  loading: () => <Loading withContentWrapper />,
});
